import { render, staticRenderFns } from "./DownloadFrame.vue?vue&type=template&id=39a0a3b1&"
import script from "./DownloadFrame.vue?vue&type=script&lang=js&"
export * from "./DownloadFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports